<template>
  <div class="page-container pt-3 pb-4 topics-table">
    <div class="title mb-2 d-flex justify-content-between align-items-center">
      <h3 v-if="topic" class="text-blue">
        <template v-if="$route.params.topic">
          <span
            ><router-link :to="topicHeadingWithLink.parentUrl">{{ topicHeadingWithLink.parentName }}</router-link></span
          >
          <span>{{ topicHeadingWithLink.text }}</span>
        </template>
        <template v-else>{{ topicHeading }}</template>
      </h3>
    </div>

    <v-server-table
      ref="topicsTable"
      name="topicsTable"
      v-if="topic"
      :url="'/api/topics/' + topic.id + '/shiurim'"
      :columns="columns"
      :options="options"
      :class="tableClass"
    >
      <div slot="beforeTable" class="py-3 d-md-none">
        <div class="d-flex flex-wrap w-100 align-items-center justify-content-center">
          <strong clas="col-auto">{{ $_t('KW:filterBy') }}</strong>
          <input class="form-control w-100 search-filter" v-model="filtername" :placeholder="$_t('KW:searchShiurim')" />
          <v-select
            v-if="topic.magideishiur.length > 0"
            class="select-filter w-100"
            v-model="filterSpeakers"
            :placeholder="$_t('KW:filterMagidShiur')"
            :options="topic.magideishiur"
          ></v-select>
          <v-select
            v-if="topic.children"
            class="select-filter w-100"
            v-model="filterTopics"
            :placeholder="$_t('KW:filterByTopic')"
            :options="topic.children"
          ></v-select>
        </div>
        <div class="d-flex w-100 align-items-center justify-content-center">
          <strong clas="col-auto">{{ $_t('KW:sortBy') }}:</strong>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('name')">
            {{ $_t('KW:name') }}
            <i class="fa" :class="setOrderClass('name')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link topic-sort" @click="sortItems('topic_id')">
            {{ $_t('KW:topic') }}
            <i class="fa" :class="setOrderClass('topic_id')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link magid-sort" @click="sortItems('speaker_id')">
            {{ $_t('KW:speaker') }}
            <i class="fa" :class="setOrderClass('speaker_id')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('recorded')">
            {{ $_t('KW:date') }}
            <i class="fa" :class="setOrderClass('recorded')"></i>
          </button>
          <button class="col-auto btn btn-sm btn-link" @click="sortItems('length')">
            {{ $_t('KW:length') }}
            <i class="fa" :class="setOrderClass('length')"></i>
          </button>
        </div>
      </div>
      <div slot="filter__name">
        <input class="form-control search-filter" v-model="filtername" :placeholder="$_t('KW:searchShiurim')" />
      </div>
      <div slot="mobile" slot-scope="props">
        <strong>
          <a :href="'/shiur/' + props.row.id">
            {{ props.row.name }}
          </a>
        </strong>
        {{ props.row.length }}
        <br />
        <speaker-slot :magid-shiur="magidShiur(props.row.speaker_id)" type="torah"></speaker-slot>
        <topic-slot v-if="topic.children" :topics="topic.children" :topic-id="props.row.topic_id"></topic-slot>
        <span v-if="!topic.children">{{ topic.name }}</span>
      </div>
      <a slot="name" slot-scope="props" :href="'/shiur/' + props.row.id">{{ props.row.name }}</a>
      <v-select
        v-if="topic.magideishiur.length > 0"
        slot="filter__speaker_id"
        class="select-filter"
        v-model="filterSpeakers"
        :placeholder="$_t('KW:filterByMagidShiur')"
        :options="topic.magideishiur"
      ></v-select>
      <v-select
        v-if="topic.children"
        slot="filter__topic_id"
        class="select-filter"
        v-model="filterTopics"
        :placeholder="$_t('KW:filterByTopic')"
        :options="topic.children"
      ></v-select>
      <speaker-slot slot="speaker_id" slot-scope="props" :magid-shiur="magidShiur(props.row.speaker_id)" type="torah"></speaker-slot>
      <topic-slot slot="topic_id" slot-scope="props" :topics="topic.children" :topic-id="props.row.topic_id" />
      <action-buttons slot="actions" :magid-shiur="magidShiur(props.row.speaker_id)" :shiurim="props.row" type="torah" slot-scope="props"></action-buttons>
    </v-server-table>
  </div>
</template>
<script>
import VueSelect from 'vue-select';
import { Event as VueTablesEvent } from 'vue-tables-2';
import ActionButtonsComponent from '../partials/ActionButtons.vue';
import TopicLinkComponent from '../magideiShiur/topicLink.vue';
import speakerSlotComponent from './speakerSlot.vue';
import topicSlotComponent from './topicSlot.vue';

export default {
  metaInfo: function () {
    return { title: this.topicHeading };
  },
  components: {
    vSelect: VueSelect,
    ActionButtons: ActionButtonsComponent,
    TopicLink: TopicLinkComponent,
    SpeakerSlot: speakerSlotComponent,
    topicSlot: topicSlotComponent,
  },
  data: function () {
    return {
      filterSpeakers: null,
      filterTopics: null,
      filtername: null,
      topic: null,
      //columns: columns,
      options: {
        headings: {
          mobile: '',
          title: this.$_t('KW:name'),
          topic_id: this.$_t('KW:topic'),
          speaker_id: this.$_t('KW:magidShiur'),
          name: this.$_t('KW:title'),
          recorded: this.$_t('KW:date'),
          length: this.$_t('KW:time'),
          actions: this.$_t('KW:playOrDownload'),
        },
        sortIcon: {
          base: 'fa fa-sort',
          up: 'fa-sort-amount-asc',
          down: 'fa-sort-amount-desc',
        },
        columnsDisplay: {
          mobile: 'max_tabletP',
          name: 'min_tabletL',
          speaker_id: 'min_tabletL',
          topic_id: 'min_tabletL',
          length: 'min_tabletL',
          recorded: 'min_tabletL',
        },
        sortable: ['name', 'topic_id', 'length', 'recorded'],
        highlightMatches: true,
        filterByColumn: true,
        filterable: [],
        customFilters: ['name', 'topic_id', 'speaker_id'],
        perPage: 50,
        perPageValues: [25, 50, 100],
      },
      order: {
        column: null,
        isAscending: true,
      },
    };
  },
  computed: {
    topicHeading: function () {
      if (this.topic) {
        if (this.$route.params.topic) {
          return this.topic.parent.name + (this.isRTL ? ' « ' : ' » ') + this.topic.name;
        } else {
          return this.topic.name;
        }
      }
      return;
    },
    topicHeadingWithLink: function () {
      return {
        parentName: this.topic.parent.name,
        parentUrl: '/topic/' + this.topic.parent.url_key,
        text: (this.isRTL ? ' « ' : ' » ') + this.topic.name,
      };
    },
    columns: function () {
      let columns = this.$route.params.topic
        ? ['mobile', 'name', 'speaker_id', 'recorded', 'length', 'actions']
        : ['mobile', 'name', 'speaker_id', 'topic_id', 'recorded', 'length', 'actions'];

      // if (this.topic.magideishiur && this.topic.magideishiur.length < 2) {
      //   var remove = function (array, element) {
      //     const index = array.indexOf(element);
      //     array.splice(index, 1);
      //   };
      //   remove(columns, "speaker_id");
      // }
      return columns;
    },
    tableClass: function () {
      var res = '';
      if (this.topic.magideishiur && this.topic.magideishiur.length < 2) {
        res = res + 'no-magidshiur-col';
      } else {
        res = res + 'magidshiur-col';
      }
      if (this.topic.children.length == 0) {
        res = res + ' no-topic-col';
      } else {
        res = res + ' topic-col';
      }
      return res;
    },
  },
  created: function () {
    this.getData();
  },
  watch: {
    filterTopics: function () {
      VueTablesEvent.$emit('vue-tables.topicsTable.filter::topic_id', this.filterTopics ? this.filterTopics.value : '0');
    },
    filterSpeakers: function () {
      VueTablesEvent.$emit('vue-tables.topicsTable.filter::speaker_id', this.filterSpeakers ? this.filterSpeakers.value : '0');
    },
    filtername: function () {
      VueTablesEvent.$emit('vue-tables.topicsTable.filter::name', this.filtername);
    },
    $route: 'getData',
  },
  methods: {
    slug: function (val) {
      if (val) {
        var result = val
          .toString()
          .toLowerCase()
          .replace(/\s+/g, '-') // Replace spaces with -
          .replace(/[^\w\-]+/g, '') // Remove all non-word chars
          .replace(/\-\-+/g, '-') // Replace multiple - with single -
          .replace(/^-+/, '') // Trim - from start of text
          .replace(/-+$/, ''); // Trim - from end of text
        if (!result || 0 === result.length) {
          return 'hebrew';
        }
        return result;
      }
      return 'not-specified';
    },
    magidShiur: function (id) {
      if (this.topic.magideishiur) {
        var filtered = this.topic.magideishiur.filter(function (magidShiur) {
          return magidShiur.value == id;
        });
        return {
          name: filtered[0].label,
          url_key: filtered[0].url_key,
          // image_url: '',
        };
      }
    },
    sortItems: function (column) {
      if (this.order.column !== column) {
        this.order.column = column;
        this.order.isAscending = true;
      } else {
        this.order.isAscending = !this.order.isAscending;
      }
      this.$refs.topicsTable.setOrder(this.order.column, this.order.isAscending);
    },
    setOrderClass: function (name) {
      if (name == this.order.column) {
        return this.order.isAscending ? 'fa-sort-amount-asc' : 'fa-sort-amount-desc';
      }
      return 'fa-sort';
    },
    getData: function () {
      let self = this;
      let topic = this.$route.params.topic ? this.$route.params.parenttopic + '/' + this.$route.params.topic : this.$route.params.parenttopic;
      this.loading = true;
      this.$http.get('/api/topics/' + topic).then(function (response) {
        self.topic = response.data;
        self.loading = false;
      });
    },
  },
};
</script>
<style>
.table-bordered th,
.table-bordered td {
  vertical-align: middle;
}

.no-topic-col .topic-sort,
.no-magidshiur-col .magid-sort {
  display: none;
}

.no-magidshiur-col.no-topic-col tr td:nth-child(2),
.magidshiur-col.no-topic-col tr td:nth-child(3),
.no-magidshiur-col.topic-col tr td:nth-child(3),
.magidshiur-col.topic-col tr td:nth-child(4) {
  /* width: 120px; */
}
.no-magidshiur-col.no-topic-col tr td:nth-child(3),
.magidshiur-col.no-topic-col tr td:nth-child(4),
.no-magidshiur-col.topic-col tr td:nth-child(4),
.magidshiur-col.topic-col tr td:nth-child(5) {
  /* width: 90px; */
}
</style>
<style lang="scss">
.topics-table {
  .table-hover tbody tr:hover {
    background-color: unset;
  }
  @media (max-width: 768px) {
    .VueTables {
      tr {
        border: none;
        padding-bottom: 10px;
        td:first-child {
          margin-top: 15px;
        }
        td:last-child {
          margin-bottom: 15px;
        }
        td {
          img {
            display: none;
          }
          border: none;
          text-align: center;
          .action-btn-container {
            justify-content: center;
          }
        }
      }
      .search-filter {
        height: 45px;
        margin-bottom: 15px;
      }
      .select-filter {
        margin-bottom: 15px;
        ul.dropdown-menu li {
          padding: 5px 0px;
        }
        .dropdown-toggle {
          height: 45px;
        }
      }
    }
  }
}

.topics-table {
  #VueTables_th--topic_id {
    width: 350px !important;
  }

  #VueTables_th--speaker_id {
    width: 450px !important;
  }

  #VueTables_th--actions {
    width: 150px !important;
  }
}
</style>
